import React, { useCallback, useEffect, useState } from 'react';
import _ from 'lodash';
import { useHistory, useLocation } from 'react-router-dom';

import { PwdForm } from '../common';
import { URL } from '../../../../constant';
import { appIdSignAPI } from '../../../../api/accountAPI';
import { useAlert, useInput, useLoading, useUserInfo } from '../../../../hooks';
import { emailRegExp, passwordRegExp } from '../../../../utils/utilityEtc';
import XbtnTitleHeader from '../../../common/header/XbtnTitleHeader';

function AppIdSign() {
  const history = useHistory();
  const location = useLocation();
  const [Alert] = useAlert();
  const { info, setInfo } = useUserInfo();
  const { setLoading, clearLoading } = useLoading();

  const [email, onEmailChange, onEmailReset] = useInput('');
  const [pwd, onPwdChange, onPwdReset] = useInput('');
  const [rePwd, onRePwdChange, onRePwdReset] = useInput('');

  const [emailCheck, setEmailCheck] = useState('');
  const [pwdCheck, setPwdCheck] = useState('');
  const [type, setType] = useState('sign');

  useEffect(() => {
    const { state } = location;
    if (state?.type) {
      setType(state?.type);
    }
  }, []);

  const handleMouseDown = (e) => e.preventDefault();

  const onBlur = useCallback((e) => {
    const name = e.target.name;
    // 이메일 체크
    if (_.isEqual(name, 'email')) {
      if (!email) return;
      // 이메일 양식이 맞으면  true 아니면 false;
      const result = emailRegExp(email);
      setEmailCheck(result ? 'success' : 'fail');
    }
    // 비밀번호 체크
    if (_.isEqual(name, 'pwd') || _.isEqual(name, 'rePwd')) {
      if (!passwordRegExp(pwd)) {
        setPwdCheck('pattern');
        return;
      } else if (_.isEqual(name, 'rePwd') && !_.isEqual(pwd, rePwd)) {
        setPwdCheck('diff');
        return;
      } else if (pwd.length < 8) {
        setPwdCheck('length');
        return;
      }
      setPwdCheck('success');
    }
  }, [email, pwd, rePwd]);

  const onSubmit = useCallback(async () => {

    if (!email || !pwd) return;
    const { channelCode, userId } = info;
    setLoading({ isShowSpinner: true, spinnerType: '1' });
    const resp = await appIdSignAPI({
      sbsceMbrId: userId,
      chnCd: channelCode,
      mbrId: userId,
      emailAdrs: email,
      newPw: pwd,
    });

    if (resp?.code === "S000000") {
      history.push({
        pathname: URL.ACCOUNT.APP_ID_SIGN_SUCCESS,
        state: {
          email
        }
      })
      setInfo({ emailCertYn: 'Y' })
    } else {
      if (resp?.data) {
        const { message } = resp.data;
        Alert(message);
      }
    }

    clearLoading();
  }, [email, pwd]);

  return (
    <div className="layout-def layout-lc bg_gray2">
      <XbtnTitleHeader
        title={
          _.isEqual(type, 'change')
            ? "APP 계정 변경"
            : "APP 계정 신청"
        }
        onClose={() => history.push(URL.SELECT_LEARNING)}
      />
      <div className="container">
        <div className="inner">
          {
            _.isEqual(type, 'change')
              ? (
                <div className="info_wrap">
                  <p className="info_noti">변경하실 APP 계정 이메일 주소와 비밀번호를 입력해 주세요.</p>
                </div>
              )
              : (
                <div className="app_txt_wrap">
                  <div className="txt">
                    <p>이메일과 비밀번호를 설정하시면<br />북클럽 패드 외에 <b>모든 기기에서 자유롭게</b> 학습하실 수 있습니다.</p>
                    <div className="ballon">구글 플레이에서 'AI바로셈' 다운로드!</div>
                  </div>
                </div>
              )
          }
          <div className="wirte_form gm_ver w520 pb0">
            <section>
              <div className="item">
                <div className="input_title">
                  {
                    _.isEqual(type, 'change')
                      ? "변경 이메일"
                      : "이메일"
                  }
                </div>
                <div className="input_cont h56">
                  <div className="input_box white_box">
                    <input
                      type="email"
                      name="email"
                      placeholder="이메일을 입력해 주세요."
                      value={email}
                      onBlur={onBlur}
                      onChange={onEmailChange}
                    />
                    <div className="r_area">
                      {
                        (_.isEqual(emailCheck, 'success') && !_.isEmpty(email)) && (
                          <img src="../static/images/icon/ic_check.svg" alt="" />
                        )
                      }
                      <button
                        type="button"
                        onClick={onEmailReset}
                        onMouseDown={handleMouseDown}
                      >
                        {
                          _.isEqual(emailCheck, 'fail') && (
                            <img src="../static/images/icon/ic_error.svg" alt="" />
                          )
                        }
                        {
                          (_.isEmpty(emailCheck) && !_.isEmpty(email)) && (
                            <img src="../static/images/icon/input_delete_40.svg" alt="" />
                          )
                        }
                      </button>
                    </div>
                  </div>
                  {
                    _.isEqual(emailCheck, 'fail') && (
                      <div className="info_txt red">올바른 이메일 형식이 아닙니다. 예)abc@mathpid.com</div>
                    )
                  }
                </div>
              </div>
              <PwdForm
                pwd={pwd}
                onBlur={onBlur}
                onPwdChange={onPwdChange}
                pwdCheck={pwdCheck}
                onPwdReset={onPwdReset}
                handleMouseDown={handleMouseDown}
                rePwd={rePwd}
                onRePwdChange={onRePwdChange}
                onRePwdReset={onRePwdReset}
              />
            </section>
          </div>
          <div className="page_lower_wrap mt40">
            <div className="w520">
              <button
                className="btn btn-blue"
                disabled={
                  _.isEmpty(email)
                  || _.isEmpty(pwd)
                  || _.isEmpty(rePwd)
                  || !_.isEqual(pwd, rePwd)
                  || !_.isEqual(emailCheck, 'success')
                  || !_.isEqual(pwdCheck, 'success')
                }
                onClick={onSubmit}
              >
                {
                  _.isEqual(type, 'change')
                    ? "변경하기"
                    : "신청하기"
                }
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AppIdSign;